window.APP.removeQueryParams();
window.APP.addGAFormField('contact_form');


// Add a hidden field w/ recently viewed products.
(function() {
  const recentViews = JSON.parse(localStorage.getItem('p4_recent_view_2'));
  if (recentViews === null) return;

  const list = recentViews.reduce((list, product, index) => {
    return list + `[${index + 1}]: ${product.title} <${window.location.origin + product.link}>\n`;
  },
  `
    Most recently viewed products first.
    WARNING: Views may span multiple sessions and, conceivably, across months.
    ---
  `);
  window.APP.addHiddenFormField('contact_form', 'recentViews', list);
})();
